import React, { useState, useRef, useEffect, useContext } from 'react'
import { Card, DataTable } from 'react-native-paper'
import { View, Text, ScrollView, StyleSheet, TouchableOpacity} from "react-native";
import axios from 'axios'
import Background from '../../components/Background'
import CustomParams from './CustomParams'

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.min.js";
import "datatables.net-buttons/js/buttons.html5.min.js";
// import "jszip/dist/jszip.min.js";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import $ from "jquery";

const jzip = require( 'jszip/dist/jszip.js');
window.JSZip = jzip;

import {
  DialogCostum
} from '../../components'

import { LoginContext } from '../../contexts/GlobalState'
import { monthList } from '../../utils/monthList'
import { currencyFormat } from '../../utils/currency';

export default function SPRP0014({ route, navigation }){
  $.DataTable = require('datatables.net')
  const tableRef = useRef()
  const tableName = "table"+route.name

  const homeprm = navigation.getState();
  const home = homeprm.routes[0].state.routes[0].params;
  let table;

  const [visible, setVisible] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [dataGrid, setDataGrid] = useState()
  const [office, setOffice] = useState()
  const [month, setMonth] = useState()
  const [getdate, setDate] = useState()
  const [year, setYear] = useState()
  const [reportDate, setReportDate] = useState()

  const hideDialog = () => {
    setVisible(false)
  }

  const exportTo = (exp) =>{
    if(exp==='EXCEL'){
      $( `#${tableName}_wrapper` ).find('.buttons-excel').trigger('click');
    }
    if(exp==='PDF'){
      $( `#${tableName}_wrapper` ).find('.buttons-pdf').trigger('click');
    }
  }

  const login = useContext(LoginContext)  
useEffect(() => {
    // setTimeout( function () {
    //   $(`#${tableName}`).DataTable().columns.adjust();
    // }, 500)
  }, [login]);
  useEffect(() => {
    const date = new Date(home.oprdt)
    setYear(date.getFullYear())    
    setOffice(home.brncd+' - '+home.brnm);
    setDate(date.toISOString().slice(0, 10))
    const months = monthList(home.oprdt);
    setMonth(months.month.label)
    postSubmit({
      brnm:home.brnm,
      office:{value: home.brncd},
      getdate:{value: date}
    })
  }, []);

  const postSubmit = (v) => {
    try {
      axios.post(process.env.REACT_APP_URL_API + "SPRP0014/read",  {
        method:"getreport",
        office:v.office.value,
        getdate:v.getdate.value
      }, {timeout: 120000})
      .then(res => {
        if (!res.data.data){
          if(res.data.error.responseCode){
            setErrorMessage(`${res.data.error.responseCode} - ${res.data.error.responseMsg}`);
          }else if(res.data.error.message){
            setErrorMessage(res.data.error.message);
          }else{
            setErrorMessage(res.data.error);
          }
          setVisible(true);
        }else{
          setOffice(v.office.value+' - '+v.brnm)
          setDate(v.getdate.value.toISOString().slice(0, 10));

          setDataGrid(res.data.data)
          setReportDate(res.data.reportdate)
          // const months = monthList(new Date(v.year.value+"-"+(v.month.value+1)+"-01"))
          // setMonth(months.month.label)

          const title = 'LAPORAN COST OF FUND'+'\n'+ login.bankname+'\n'+ v.office.value+' - '+v.brnm.toUpperCase()+'\n'+reportDate

          table = $(`#${tableName}`).DataTable(
            {
              data: res.data.data,
              scrollY:"360px",
              scrollX:true,
              scrollCollapse: true,
              fixedHeader: true,
              dom: "lBfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  title: 'LAPORAN COST OF FUND'+'\n'+ login.bankname+'\n'+ v.office.value+' - '+v.brnm.toUpperCase()+'\n'+res.data.reportdate,
                  // messageTop: ,
                },
                {
                  extend: 'pdfHtml5',
                  orientation:'landscape',
                  pageSize: 'LEGAL',
                  title: 'LAPORAN COST OF FUND'+'\n'+ login.bankname+'\n'+ v.office.value+' - '+v.brnm.toUpperCase()+'\n'+res.data.reportdate,
                  // messageTop: ,
                  customize: function (doc) { 
                    doc.styles.title = {
                      fontSize: '12',
                      alignment: 'center'
                    }   
                    var rowCount = doc.content[1].table.body;
                    for (let i = 0; i < rowCount.length; i++) {
                      rowCount[i][1].alignment = 'right';
                      rowCount[i][2].alignment = 'right';
                      rowCount[i][3].alignment = 'right';
                      rowCount[i][5].alignment = 'right';
                      rowCount[i][4].alignment = 'right';
                    }
                  }
                },
              ],
              columnDefs: [
                { targets: [1,2,3,4,5], className: 'dt-body-right' },
                { targets: [1,2,3,4,5], className: 'dt-head-right' }
              ],
              columns: [
                { title: "SUMBER DANA"},
                { title: "TOTAL BIAYA BUNGA"},
                { title: "TOTAL JUMLAH DANA"},
                { title: "% KOMPOSISI DANA"},
                { title: "% BEBAN BUNGA"},
                { title: "% BUNGA TERTIMBANG"}
              ],
              oLanguage:{
                sSearch:"<span>Pencarian </span> _INPUT_",
                sLengthMenu:"Tampil _MENU_",
                sZeroRecords:"Tidak ada data untuk ditampilkan.",
                sInfo:"Total _TOTAL_ baris (_START_ - _END_)",
                sInfoFiltered: "", 
                sInfoEmpty: "Menampilkan 0 baris",
                oPaginate:{
                  sNext:">",
                  sPrevious:"<"
                }
              },
              searching:{
                regex:1
              },
              ordering: false,
              pageLength: -1,
              lengthMenu: [ [10, 25, 50, 100, -1], [10, 25, 50, 100, "Semua"] ],
              destroy: true,  // I think some clean up is happening here
            }
          )
          
          $('.dt-buttons').hide();
        // Extra step to do extra clean-up.
          return function() {
              console.log("Table destroyed")
              table.destroy()
          }
        }
      })
      .catch(err => {
        console.log(err);
        setErrorMessage(err.code==="ECONNABORTED"? "Server Luring": (err.message?err.message:JSON.stringify(err)) );
        setVisible(true);
      });
    } catch (err) {
      console.log(err);
      setErrorMessage('Server Luring');
      setVisible(true);
    }
  }

  return (
    <Background isVisibleBg={true}>
      <CustomParams home={home} export={exportTo} action={postSubmit} progid={route.name} />
      <Card style={{backgroundColor: 'rgba(204, 204, 255, 0.2)'}}>
      <Card.Content>
          <View style={{alignItems:'center', padding:5}}>
            <Text style={{fontSize:14, fontWeight:'bold'}}>LAPORAN COST OF FUND</Text>
            <Text style={{fontSize:14, fontWeight:'bold'}}>{login.bankname}</Text>
            <Text style={{fontSize:14, fontWeight:'bold', textTransform: 'uppercase'}}>{office}</Text>
            <Text style={{fontSize:14, fontWeight:'bold', textTransform: 'uppercase'}}>{reportDate}</Text>
          </View>

          <table
            style={{
              fontSize: '14px',
              fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
              padding:5
            }}
            className="display"
            width="100%"
            id={tableName}
            ref={tableRef}
          >
          
          </table>
        </Card.Content>
      </Card>
      <DialogCostum props={{visible, hideDialog, message:errorMessage}} />
    </Background>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 10,
    width: '100%',
  },
  row:{
    width: '60%'
  },
  bold_row:{
    fontWeight:'bold',
    // backgroundColor: '#F88379'
  }
});